(function () {
  "use strict";

  function initReveal() {
    var items = document.querySelectorAll(".mt-reveal");
    if (!items.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -60px 0px" }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  function initComparador() {
    var wraps = document.querySelectorAll("[data-mt-comparador]");
    wraps.forEach(function (wrap) {
      var antes = wrap.querySelector(".mt-comparador__antes");
      var handle = wrap.querySelector(".mt-comparador__handle");
      var boton = wrap.querySelector(".mt-comparador__boton");
      if (!antes || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        antes.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
        if (boton) boton.style.left = pct + "%";
      }

      wrap.addEventListener("pointerdown", function (e) {
        dragging = true;
        setPos(e.clientX);
      });
      window.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      window.addEventListener("pointerup", function () { dragging = false; });
      wrap.addEventListener("mousemove", function (e) {
        if (dragging) setPos(e.clientX);
      });
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll("[data-mt-galeria-producto]");
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-imagen-principal]");
      var minis = galeria.querySelectorAll("[data-mt-miniatura]");
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-full");
          if (!src) return;
          principal.style.opacity = "0";
          setTimeout(function () {
            principal.src = src;
            principal.style.opacity = "1";
          }, 160);
          minis.forEach(function (m) { m.classList.remove("mt-activa"); });
          mini.classList.add("mt-activa");
        });
      });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return (format || "€{{amount}}").replace("{{amount}}", value);
  }

  function initVariantes() {
    var forms = document.querySelectorAll("[data-mt-producto-form]");
    forms.forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var moneyFormat = form.getAttribute("data-money-format") || "€{{amount}}";
      var optionInputs = form.querySelectorAll("[data-mt-opcion]");
      var idInput = form.querySelector("input[name='id']");
      var precioActual = form.querySelector("[data-mt-precio-actual]");
      var precioAnterior = form.querySelector("[data-mt-precio-anterior]");
      var botonComprar = form.querySelector("[data-mt-comprar]");
      var estadoTexto = form.querySelector("[data-mt-estado]");

      function seleccionActual() {
        var seleccion = [];
        optionInputs.forEach(function (group) {
          var activo = group.querySelector(".mt-activa");
          seleccion.push(activo ? activo.getAttribute("data-valor") : null);
        });
        return seleccion;
      }

      function actualizar() {
        var seleccion = seleccionActual();
        var variante = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!variante) return;
        idInput.value = variante.id;
        if (precioActual) precioActual.textContent = formatMoney(variante.price, moneyFormat);
        if (precioAnterior) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAnterior.textContent = formatMoney(variante.compare_at_price, moneyFormat);
            precioAnterior.style.display = "";
          } else {
            precioAnterior.style.display = "none";
          }
        }
        if (botonComprar) botonComprar.disabled = !variante.available;
        if (estadoTexto) {
          estadoTexto.textContent = variante.available ? estadoTexto.getAttribute("data-disponible") : estadoTexto.getAttribute("data-agotado");
          estadoTexto.classList.toggle("mt-disponible", variante.available);
          estadoTexto.classList.toggle("mt-agotado", !variante.available);
        }
      }

      optionInputs.forEach(function (group) {
        var botones = group.querySelectorAll("[data-valor]");
        botones.forEach(function (btn) {
          btn.addEventListener("click", function () {
            botones.forEach(function (b) { b.classList.remove("mt-activa"); });
            btn.classList.add("mt-activa");
            actualizar();
          });
        });
      });

      var cantidadInput = form.querySelector("[data-mt-cantidad]");
      var masBtn = form.querySelector("[data-mt-cantidad-mas]");
      var menosBtn = form.querySelector("[data-mt-cantidad-menos]");
      if (masBtn && cantidadInput) masBtn.addEventListener("click", function () { cantidadInput.value = Math.max(1, parseInt(cantidadInput.value || "1", 10) + 1); });
      if (menosBtn && cantidadInput) menosBtn.addEventListener("click", function () { cantidadInput.value = Math.max(1, parseInt(cantidadInput.value || "1", 10) - 1); });

      actualizar();
    });
  }

  function initAcordeon() {
    var items = document.querySelectorAll("[data-mt-acordeon-item]");
    items.forEach(function (item) {
      var pregunta = item.querySelector("[data-mt-acordeon-pregunta]");
      var respuesta = item.querySelector("[data-mt-acordeon-respuesta]");
      if (!pregunta || !respuesta) return;
      pregunta.addEventListener("click", function () {
        var abierto = item.classList.contains("mt-abierto");
        item.parentElement.querySelectorAll("[data-mt-acordeon-item]").forEach(function (otro) {
          otro.classList.remove("mt-abierto");
          otro.querySelector("[data-mt-acordeon-respuesta]").style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add("mt-abierto");
          respuesta.style.maxHeight = respuesta.scrollHeight + "px";
        }
      });
    });
  }

  function initCifras() {
    var cifras = document.querySelectorAll("[data-mt-cifra]");
    if (!cifras.length) return;
    var animated = new WeakSet();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || animated.has(entry.target)) return;
        animated.add(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute("data-mt-cifra"));
        var suffix = el.getAttribute("data-mt-sufijo") || "";
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(current) : current.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    cifras.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initComparador();
    initGaleriaProducto();
    initVariantes();
    initAcordeon();
    initCifras();
  });
})();
